import KondoHeader from '../Header';
import KondoFooter from '../Footer';
import ContactButton from '../ContactButton'
import Pankuzu from '../pankuzu';

import story_01 from '../../images/story_01.png'
import story_02 from '../../images/story_02.png'
import story_03 from '../../images/story_03.png'

import CompanyTop from "../../images/CompanyTop.png";
// コンポーネントのインポート
import SliderSlide from '../SliderSlide';

// animation
import {motion} from "framer-motion"

const PageCompanyStory = () => {
    return(
        <div id="PageKondou">  
            <div id="PageHistory">
                <KondoHeader />
                <motion.div
                    animate={{
                        y: 0,
                        opacity: 1
                    }}
                    initial={{
                        y: 0,
                        opacity: 1
                    }}
                    exit={{
                        y: 100,
                        opacity: 0
                    }}
                    transition={{
                        duration: 0.4,
                        ease: "easeOut",
                    }}
                >
                    <main>
                        <section className='company-top'>
                            <img src={CompanyTop} alt='会社ページのトップ' />
                            <Pankuzu pagename="STORY" />
                            <article>
                                <h1>STORY</h1>
                                <h2>近藤染工場のいまむかし</h2>
                            </article>
                        </section>
                        <section className='story-history'>
                            <div>
                                <h2>
                                    <span></span>
                                    藍とともに徳島から旭川へ
                                </h2>
                                <article>
                                    <img src={story_01} alt='藍とともに徳島から旭川へ' />
                                    <p>
                                        1890年（明治23年）に四国徳島より石狩郡新篠津村に入植。1898年（明治31年）旭川に移住し、
                                        1条通3丁目に近藤染舗を開業しました。この当時の写真は北海道の歴史を知る上で非常に貴重な
                                        資料とされています。近藤染舗は当時から、袢天、のぼり、旗、のれん、帆前掛等を主に染めて
                                        いました。おかげ様で明治31年の創業以来、染一筋で現在まで営業しております。
                                    </p>
                                </article>
                            </div>
                            <div>
                                <h2>
                                    <span></span>
                                    開拓村で歴史を保存
                                </h2>
                                <article>
                                    <img src={story_02} alt='開拓村で歴史を保存' />
                                    <p>
                                        北海道開拓の村（札幌市厚別区厚別町小野幌５０番１）は明治・大正期に建築された北海道の
                                        建築物を面積54.2haに復元再現しています。ここを訪れる人たちに開拓当時の生活を体験的に
                                        理解してもらうことと、文化の流れを示す建築物を後世に伝えるため永く保存することを目的
                                        とした野外博物館です。大正初期の名残を伝える当近藤染工場の旧店舗も、北海道のご要請に
                                        よりここに仲間入りさせていただきました。
                                    </p>
                                </article>
                            </div>
                            <div>
                                <h2>
                                    <span></span>
                                    現在そして未来
                                </h2>
                                <article>
                                    <img src={story_03} alt='現在そして未来' />
                                    <p>
                                        変わらぬこの旭川で、今を大切に、古の技を地道に磨き続けながら、未来へ向けて進化し続け
                                        ています。将来、ここには「いまこのとき」の出来事がどんなふうに書かれることでしょう？
                                        皆様と近藤染工場で、ともに「いまこのとき」を創っていくことができれば幸いです。
                                    </p>
                                </article>
                            </div>
                        </section>
                        <section>
                            <article className='company-history'>
                                <h1>HISTORY</h1>
                                <h2>近藤染工場の歴史</h2>
                            </article>
                            <table>
                                <tr>
                                    <th className='table-th-first'>1890年（明治23年）</th>
                                    <span>：</span>
                                    <td>四国徳島より渡道、石狩郡新篠津村に入植</td>
                                </tr>
                                <tr>
                                    <th>1898年（明治31年）</th>
                                    <span>：</span>
                                    <td>
                                        旭川市に移住し、1条通3丁目に「近藤染舗」を開業する（現在も同住所）袢天、のぼり、旗 、のれん、帆前掛等を主に染める。旭川－滝川間に鉄道が開通
                                    </td>
                                </tr>
                                <tr>
                                    <th>1913年（大正2年）</th>
                                    <span>：</span>
                                    <td>2代目店舗兼住宅を新築（現在、北海道開拓の村に保存）</td>
                                </tr>
                                <tr>
                                    <th>1950年（昭和25年）</th>
                                    <span>：</span>
                                    <td>社名を「株式会社近藤染工場」に改称</td>
                                </tr>
                                <tr>
                                    <th>1983年（昭和58年）</th>
                                    <span>：</span>
                                    <td>店舗の建物を「北海道開拓の村」に寄贈</td>
                                </tr>
                                <tr>
                                    <th>1984年（昭和59年）</th>
                                    <span>：</span>
                                    <td>新社屋完成</td>
                                </tr>
                                <tr>
                                    <th>1998年（平成10年）</th>
                                    <span>：</span>
                                    <td>創業100年</td>
                                </tr>
                                <tr>
                                    <th>2008年（平成20年）</th>
                                    <span>：</span>
                                    <td>創業110年</td>
                                </tr>
                                <tr>
                                    <th>2018年（平成30年）</th>
                                    <span>：</span>
                                    <td>
                                        創業120年<br/>
                                        近藤染工場展開催 本物の染を求められるお客様から、広くご愛顧いただき、現在に至る。
                                    </td>
                                </tr>
                            </table>
                        </section>
                        <section className='slider-slide'>
                            <SliderSlide />
                        </section>
                    </main>
                    <ContactButton />
                    <KondoFooter />
                </motion.div>
            </div>
        </div>
    )
}
export default PageCompanyStory;